const bannerSlide = [
  {
    h2: "홈페이지 제작 <br />월 5만원, 광고까지",
  },
  {
    h2: "홈페이지를 넘어<br />광고까지",
  },
  {
    h2: "손님을 끌어들이는 <br />홈페이지",
  },
]

const bannerLink = [
  {
    imageUrl: "원페이지",
    p: "원페이지형 <br />홈페이지",
    url: "portfolio/01"
  },
  {
    imageUrl: "표준형",
    p: "표준형 <br />홈페이지",
    url: "portfolio/02"
  },
  {
    imageUrl: "심화개발형",
    p: "심화개발형 <br />홈페이지",
    url: "portfolio/03"
  },
  {
    imageUrl: "쇼핑몰",
    p: "쇼핑몰 <br />홈페이지",
    url: "portfolio/04"
  },
]

export { bannerSlide, bannerLink };